import React, { useState, useEffect, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';

const FunMathQuizGame = () => {
  const [score, setScore] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('');
  const [confettiElements, setConfettiElements] = useState([]);
  const [answerValue, setAnswerValue] = useState('');
  const inputRef = useRef(null);

  
  const questions = [
    { q: "What time is shown: Short hand on 4, long hand on 12?", a: "4:00" },
    { q: "What time is shown: Hour hand on 9, minute hand on 6?", a: "9:30" },
    { q: "What is 1 hour after 2:15?", a: "3:15" },
    { q: "The time is 2:45 now. What time will it be 1 hour and 30 minutes later?", a: "4:15" },
    { q: "If the clock shows 11:50, what time will it be after 25 minutes?", a: "12:15" },
    { q: "What time will it be 45 minutes after 7:20?", a: "8:05" },
    { q: "What time is 30 minutes before 6:00?", a: "5:30" },
    { q: "What time does the clock show: Hour hand between 2 and 3, minute hand on 6?", a: "2:30" },
    { q: "If school starts at 8:00 and it's 7:45 now, how many minutes are left?", a: "15" },
    { q: "Sarah has 12 apples and gives 5 away. How many are left?", a: 7 },
    { q: "John read 18 pages on Monday and 22 on Tuesday. How many pages total?", a: 40 },
    { q: "A pen costs ₹18. How much for 4 pens?", a: 72 },
    { q: "There are 5 boxes. Each has 6 toys. How many toys in total?", a: 30 },
    { q: "A watermelon weighs 3 kg. What is the total weight of 4 watermelons?", a: "12" },
    { q: "If a clock chimes every hour, how many times will it chime in 6 hours?", a: 6 },
    { q: "If 2 pencils cost ₹10, how much do 4 pencils cost?", a: "20" },
    { q: "What comes next in the pattern: 5, 10, 15, _, _", a: "20, 25" },
    { q: "A shape has 4 equal sides and 4 corners. What is it?", a: "Square" },
    { q: "Which is heavier: 1 kg of feathers or 1 kg of stones?", a: "Both are equal" },
    { q: "A ball bounces every 3 seconds. How many times in 15 seconds?", a: 5 },
    { q: "Which shape has 4 equal sides and 4 right angles?", a: "Square" },
    { q: "A cube has how many faces?", a: 6 },
    { q: "Which shape has no corners and only one curved side?", a: "Circle" },
    { q: "Which 2D shape has 8 sides?", a: "Octagon" },
    { q: "An angle less than 90° is called _?", a: "Acute angle" },
    { q: "An angle that is exactly 90° is called a _?", a: "Right angle" },
    { q: "An angle more than 90° but less than 180° is called?", a: "Obtuse angle" },
    { q: "How many right angles does a rectangle have?", a: 4 },
    { q: "A straight line makes what type of angle?", a: "Straight angle" },
    { q: "True or False: All triangles have 3 angles", a: "True" }
  ];

  const normalizeAnswer = (input) => input.trim().toLowerCase().replace(/\s+/g, '');

  const checkAnswer = (e) => {
    e.preventDefault();
    const userAnswerRaw = answerValue;
    const correctAnswer = questions[currentQuestionIndex].a;
    let isCorrect = false;

    if (typeof correctAnswer === 'number') {
      isCorrect = Number(userAnswerRaw) === correctAnswer;
    } else {
      isCorrect = normalizeAnswer(userAnswerRaw) === normalizeAnswer(correctAnswer);
    }

    if (isCorrect) {
      setScore((prev) => prev + 1);
      setFeedback('🎉 Correct!');
      setFeedbackColor('#2e7d32');
      showConfetti();
    } else {
      setFeedback(`❌ Wrong! The correct answer is: ${correctAnswer}`);
      setFeedbackColor('#c62828');
    }

    setAnswerValue(''); // Clear input right away

    setTimeout(() => {
      setCurrentQuestionIndex((prev) => prev + 1);
      setFeedback('');
    }, 2000);
  };

  const showConfetti = () => {
    const elements = [];
    for (let i = 0; i < 30; i++) {
      elements.push(
        <div
          key={i + Math.random()}
          style={{
            position: 'fixed',
            width: '10px',
            height: '10px',
            backgroundColor: `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`,
            opacity: 0.8,
            pointerEvents: 'none',
            animation: `fall ${2 + Math.random() * 2}s linear forwards`,
            left: Math.random() * window.innerWidth + 'px'
          }}
        ></div>
      );
    }
    setConfettiElements(elements);
    setTimeout(() => setConfettiElements([]), 3000);
  };

  const question = questions[currentQuestionIndex];

  // Handle quiz completion
  useEffect(() => {
    if (currentQuestionIndex === questions.length) {
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }
  }, [currentQuestionIndex]);

  // Clear and focus input when question changes
  useEffect(() => {
    setAnswerValue('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [currentQuestionIndex]);

  return (
    <div style={{
      fontFamily: 'Poppins, sans-serif',
      backgroundImage: 'url("https://static.vecteezy.com/system/resources/thumbnails/021/826/876/small_2x/hand-drawn-math-symbols-icon-in-flat-style-mathematics-formula-illustration-on-isolated-background-school-education-sign-business-concept-vector.jpg")',
      minHeight: '100vh',
      overflowX: 'hidden'
    }}>
      {confettiElements}
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: '2%' }}>
        <div style={{ background: '#fff', border: '3px solid #4a148c', borderRadius: '3rem', padding: '40px 30px 50px', maxWidth: '500px', width: '90%', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2.5rem', color: '#4a148c', fontFamily: 'Comic Neue, cursive', textShadow: '0.1rem 0.1rem 0.1rem #b39ddb' }}>
            Score → <span>{score}</span>
          </h2>
          <h3 style={{ fontSize: '1.4rem', margin: '1.5rem 0 1.5rem', minHeight: '3em' }}>
            {question ? question.q : `🎉 Quiz Complete! Your final score is ${score} / ${questions.length}`}
          </h3>
          {question && (
            <form onSubmit={checkAnswer} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <input
                ref={inputRef}
                name="answer"
                type="text"
                required
                autoComplete="off"
                inputMode="numeric"
                value={answerValue}
                onChange={(e) => setAnswerValue(e.target.value)}
                style={{ fontSize: '2rem', padding: '1rem', border: '0.1rem solid #4a148c', borderRadius: '1rem', textAlign: 'center' }}
              />
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', marginTop: '1rem' }}>
  <button
    type="button"
    onClick={() => {
      setCurrentQuestionIndex((prev) => Math.max(prev - 1, 0));
      setFeedback('');
    }}
    style={{
      flex: 1,
      padding: '1rem',
      backgroundColor: '#6a1b9a',
      color: '#fff',
      fontSize: '1rem',
      fontWeight: 700,
      border: 'none',
      borderRadius: '15px',
      cursor: currentQuestionIndex === 0 ? 'not-allowed' : 'pointer',
      opacity: currentQuestionIndex === 0 ? 0.5 : 1,
    }}
    disabled={currentQuestionIndex === 0}
  >
    Previous
  </button>

  <button
    type="button"
    onClick={() => {
      setCurrentQuestionIndex((prev) =>
        Math.min(prev + 1, questions.length - 1)
      );
      setFeedback('');
    }}
    style={{
      flex: 1,
      padding: '1rem',
      backgroundColor: '#4a148c',
      color: '#fff',
      fontSize: '1rem',
      fontWeight: 700,
      border: 'none',
      borderRadius: '15px',
      cursor:
        currentQuestionIndex === questions.length - 1 ? 'not-allowed' : 'pointer',
      opacity: currentQuestionIndex === questions.length - 1 ? 0.5 : 1,
    }}
    disabled={currentQuestionIndex === questions.length - 1}
  >
    Next
  </button>
</div>

              <button
                type="submit"
                style={{ padding: '1rem', backgroundColor: '#4a148c', color: '#fff', fontSize: '1.7rem', fontWeight: 700, border: 'none', borderRadius: '1rem', cursor: 'pointer' }}
              >
                Submit
              </button>
            </form>
          )}
          <div style={{ fontSize: '1.5rem', marginTop: '1rem', height: '3rem', fontWeight: 700, fontFamily: 'Comic Neue, cursive', color: feedbackColor }}>
            {feedback}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes fall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(600px) rotate(360deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default FunMathQuizGame;
